<template>
<div class="container-fluid bg-white">
	<expense-toolbar heading="Expenses"></expense-toolbar>

	<h3>Add Expenses</h3>

	<div class="row">
		<div class="col-md-6">
			<form v-on:submit.prevent="addExpense">

				<form-group label="Invoice" col-class="col-md-4" :invalid="$store.errorList.image_id">
					<upload-field-with-panel
						api-model="ReceiptImage"
						upload-type="image/pdf"
						v-model="uploadedImage"
						v-on:uploaded="imageUploaded">
					</upload-field-with-panel>
				</form-group>

				<div class="row">
					<div class="col-md-4"></div>
					<div class="col-md-8">
						<button
							type="button"
							class="btn btn-primary d-flex justify-content-center align-items-center w-100 mb-5"
							:disabled="!expense.image_id || predictionFetched"
							v-on:click="predictFile">
							<i class="fa fa-magic mr-2"></i>
							Auto-Fill with AI
						</button>
					</div>
				</div>

				<field label="Date of Purchase" 
					col-class="col-md-4" 
					:params="{type: 'date'}" 
					v-model="expense.purchase_date"
					v-on:change="dateOfPurchaseChange"
					:invalid="$store.errorList.purchase_date">

					<alert
						:message="purchaseDateError"
						:visible="purchaseDateError"
						classes="mt-1 alert-danger"
						icon="fa-warning"
						v-on:close="purchaseDateError = false">		
					</alert>

				</field>

				<field label="Due Date" 
					col-class="col-md-4" 
					:params="{type:'date'}" 
					v-model="expense.due_date"
					:invalid="$store.errorList.due_date">
				</field>

				<job-picker
					v-if="!expense.service_id" 
					col-class="col-md-4" 
					v-model="expense.job_id"
					job-type="project"
					key="project"
					v-on:change="setSelectedJob($event,'Job')"
					:invalid="$store.errorList.job_id">
				</job-picker>

				<job-picker
					v-if="!expense.job_id" 
					col-class="col-md-4" 
					v-model="expense.service_id"
					job-type="service"
					key="service"
					v-on:change="setSelectedJob($event,'Service')"
					:invalid="$store.errorList.service_id">
				</job-picker>

				<field label="Vendor Invoice #" 
					col-class="col-md-4" 
					v-model="expense.invoice_num"
					v-on:change="checkSupplierInvoiceNum"
					:invalid="$store.errorList.invoice_num">
				</field>

				<template v-if="expense.job_id > 0 || expense.service_id > 0">

					<field label="Is this expense for a Purchase Order?"
						col-class="col-md-8"
						:float-control-right="true"
						:params="{type:'btn-group',buttons:[{text:'Yes',value:true},{text:'No',value:false}]}"
						v-model="hasPurchaseOrder"
						v-on:change="poToggleChange">
					</field>

					<template v-if="hasPurchaseOrder !== null">
						<field v-if="hasPurchaseOrder"
							label="Purchase Order" 
							col-class="col-md-4" 
							:params="{type:'select',options:purchaseOrderOptions}"
							v-on:change="poSelected"
							:invalid="$store.errorList.purchase_order_id">	
						</field>

						<div v-else>
							<field
								label="Supplier"
								col-class="col-md-4"
								v-model="expense.supplier_id"
								:params="{type:'select',options:supplierOptions}"
								v-on:change="checkSupplierInvoiceNum">
							</field>

							<div v-if="showSupplierWarning" class="row justify-content-end no-gutters ml-3">
								<div class="alert alert-warning p-2 pl-3 col-md-8">
									An expense for this supplier with this vendor invoice # already exists
								</div>
							</div>
						</div>

						<template v-if="expense.purchase_order_id > 0 || expense.supplier_id > 0">

							<div v-if="supplierLabel">

								<field
									label="Supplier"
									col-class="col-md-4"
									:readonly="true"
									:value="supplierLabel">
								</field>

								<div v-if="showSupplierWarning" class="row justify-content-end no-gutters ml-3">
									<div class="alert alert-warning p-2 pl-3 col-md-8">
										An expense for this supplier with this vendor invoice # already exists
									</div>
								</div>
							</div>

							<field label="Description" 
								col-class="col-md-4" 
								v-model="expense.description">
							</field>

							<field label="Expense Group" 	
								col-class="col-md-4" 
								:params="{type: 'select', options: expenseGroupOptions}" 
								v-on:change="groupSelected" 
								v-model="expense.group_id"
								:invalid="$store.errorList.group_id">
							</field>

							<field v-if="expense.group_id > 0" 
								label="Expense Code" 
								col-class="col-md-4" 
								:params="{type: 'select', options: expenseCodesFilteredOptions}" 
								v-model="expense.code_id"
								:invalid="$store.errorList.code_id">	
							</field>

							<div v-if="!hasTax && !qboIsActive" class="mb-2 float-right">
								<button class="btn btn-success" type="button" v-on:click="hasTax = true">
									<i class="fa fa-percent"></i>
									Has Tax
								</button>
							</div>
							<div style="clear: both;"></div>

							<field :label="hasTax || qboIsActive ? 'Subtotal $' : 'Total $'"
								col-class="col-5 col-md-4"
								v-model="expense.cost"
								:params="{type:'number',step:0.01}"
								:invalid="$store.errorList.cost">
							</field>


							<!--<form-group  >

								<input class="form-control" type="number" step="0.01" v-model="expense.cost" name="total" required style="padding: 5px;font-size:24pt;text-align: center;box-shadow: inset 0 0 10px #e0e0e0">
							</form-group>-->

							<field v-if="qboIsActive"
								label="Tax Paid"
								col-class="col-5 col-md-4"
								:params="{type:'select',options:qboSalesTaxOptions}"
								v-model="expense.qbo_tax_id"
								:invalid="$store.errorList.qbo_tax_id"
								v-on:change="getQboTaxRate">
							</field>

							<field v-else-if="hasTax" label="Tax Paid"
								col-class="col-5 col-md-4" 
								:params="{type:'number',step:'0.01'}" 
								v-model="expense.tax">		
							</field>

							<form-group v-if="hasTax"  label="" col-class="col-md-4">
								<div class="expense-total">
									<div class="float-left">Total</div>
									<div class="total-amount">$ {{calcExpenseTotal(expense)}}</div>
								</div>
							</form-group>

							<button type="submit" class="btn btn-primary btn-lg" style="display: block;width: 100%">
								<i class="fa fa-paper-plane"></i>
								Add Expense
							</button>
						</template>
					</template>
				</template>
			</form>
		</div>
		<div class="col-md-6">
			<div style="max-width: 600px;max-height: 600px;overflow-y: auto;padding: 10px;">
				<pdf-js v-if="poPreviewSrc" :url="poPreviewSrc"></pdf-js>
			</div>
		</div>
	</div>
	<hr>
	<div class="pb-4">
		<h3>Queued Expenses</h3>

		<table-list
			record-name="Expense"
			:fields="fields"
			:records="mutatedExpensesToAdd"
			:has-delete="!isEditing"
			:has-edit="!isEditing"
			:hide-record-count="true"
			:other-buttons="[
				{
					text: 'Copy',
					icon: 'fa-copy',
					click: 'copyExpense',
					class: 'btn-light'
				}
			]"
			v-on:copyExpense="copyExpense"
			v-on:edit="editExpense"
			v-on:delete="removeExpense">
		</table-list>
		
		<button class="btn btn-lg btn-primary float-right" :disabled="working || mutatedExpensesToAdd.length == 0" v-on:click="submitExpenses">
			<i class="fa" :class="{'fa-paper-plane' : !working,'fa-spinner fa-spin':working}"></i>
			Submit All Expenses
		</button>
		<div style="clear: both;"></div>
	</div>

</div>
</template>

<script>

import ExpenseToolbar from "@/pages/expenses/ExpenseToolbar"

import TableList from "@/components/TableList"
import FormGroup from "@/components/FormGroup"
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog"
import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"
import PdfJs from "@/components/PdfJs"
import Alert from "@/components/Alert"
import JobPicker from "@/components/super_components/JobPicker"

import ExpenseMixins from "@/mixins/ExpenseMixins.js"
import moment from "moment"


export default {
	name: 'ExpenseSubmitNew',
	components: {
		ExpenseToolbar,
		ModalDialog,
		FormGroup,
		Field,
		UploadFieldWithPanel,
		PdfJs,
		TableList,
		Alert,
		JobPicker
	},
	mixins: [ExpenseMixins],
	data() {
		return {
			expense: {},
			uploadedImage: null,
			expensesToAdd: [],
			purchaseOrders: [],
			suppliers: [],
			expenseCodesFiltered: [],
			hasPurchaseOrder: null,
			hasTax: false,
			working: false,
			isEditing: false,
			purchaseDateError: false,
			selectedJob: null,
			fields: [
				{label: "Purchase Date",key: "purchaseDate"},
				{label: "Subtotal",key: "cost",align: "right"},
				{label: "Tax",key: "taxAmountDisplay",align: "right"},
				{label: "Total",key: "totalDisplay",align: "right"},
				{label: "Project/Service",key: "jobNum"},
				{label: "Purchase Order",key: "poNum"},
				{label: "Supplier",key: "supplierName"},
				{label: "Invoice No.",key: "invoice_num"},
				{label: "Expense Code",key: "expenseCodeName"},
				{label: "Description",key: "description"}
			],
			poPreviewSrc: false,
			showSupplierWarning: false,

			predictionFetched: false // Only display AI button if current file hasn't already been predicted
		}
	},
	watch: {
		qboIsActive() {
			this.fetchQboSalesTaxes()
		}
	},
	computed: {
		requiredFields() {
			let fields = ["purchase_date","cost","group_id","code_id","image_id"]

			if (this.qboIsActive)
				fields.push("qbo_tax_id")
			else if (this.hasTax) 
				fields.push("tax")

			if ((!("service_id" in this.expense) || !this.expense.service_id) && (!("job_id" in this.expense) || !this.expense.job_id)) {
				fields.push("job_id")
				fields.push("service_id")
			}

			if (this.hasPurchaseOrder)
				fields.push("purchase_order_id")

			if (!this.hasPurchaseOrder)
				fields.push("supplier_id")

			return fields
		},
		expenseCodesFilteredOptions() {
			return this.optionify(this.expenseCodesFiltered,"display")
		},
		purchaseOrderOptions() {
			let vm = this

			return this.optionify(this.purchaseOrders.map(po => {

				po.displayField = vm.selectedJob.job_num+"-"+po.po_num+": "+po.subject

				return po
			}),"displayField")
		},
		supplierLabel() {
			this.showSupplierWarning  // trigger update

			if ("purchase_order_id" in this.expense && this.expense.purchase_order_id > 0) {
				let po = this.purchaseOrders.find(po => po.id == this.expense.purchase_order_id)
				return po.Supplier.name
			}
			return false
		},
		supplierOptions() {
			return this.optionify(this.suppliers,"name")
		},
		mutatedExpensesToAdd() {
			let vm = this

			return this.expensesToAdd.map(expense => {
				expense.purchaseDate = vm.formatDate(expense.purchase_date)

				let job
				if ("Job" in expense && expense.Job) {
					job = expense.Job

					expense.jobNum = "Project #"+job.job_num
				}
				else if ("Service" in expense && expense.Service) {
					job = expense.Service

					expense.jobNum = "Service #"+job.job_num
				}

				expense.poNum = ""
				expense.supplierName = ""
				expense.expenseCodeName = ""

				if (job) {
					if ("PurchaseOrder" in expense && expense.PurchaseOrder) {
						expense.poNum = job.job_num+"-"+expense.PurchaseOrder.po_num+": "+expense.PurchaseOrder.subject
						expense.supplierName = expense.PurchaseOrder.Supplier.name
					}
					else if ("Supplier" in expense && expense.Supplier) {
						expense.supplierName = expense.Supplier.name
					}

					if ("ExpenseCode" in expense && expense.ExpenseCode)
						expense.expenseCodeName = expense.ExpenseCode.code + ": " + expense.ExpenseCode.description
				}

				expense.total = +expense.cost

				expense.taxAmountDisplay = "0.00"

				if (expense.taxAmount) {
					expense.taxAmount = +expense.taxAmount
					expense.taxAmountDisplay = expense.taxAmount.toCurrency()
					expense.total += +expense.taxAmount
				}

				expense.totalDisplay = expense.total.toCurrency()

				return expense
			})
		}
	},
	methods: {

		mapPredictionToExpense(pred) {

			// Purchase date
			this.expense.purchase_date = null
			try {
				const purchaseDate = moment.utc(pred.purchase_datetime).format("YYYY-MM-DD");
				this.expense.purchase_date = purchaseDate
			} catch {}
			this.$store.errorList.purchase_date = !Boolean(this.expense.purchase_date)

			
			// Due date
			this.expense.due_date = null
			try {
				const dueDate = moment.utc(pred.due_date).format("YYYY-MM-DD");
				this.expense.due_date = dueDate
			} catch {}
			this.$store.errorList.due_date = !Boolean(this.expense.due_date)


			// Invoice number
			this.expense.invoice_num = ('transaction_number' in pred) ? pred.transaction_number : ''
			this.$store.errorList.invoice_num = !Boolean(this.expense.invoice_num)

			// Tax
			this.expense.tax = ('tax_paid' in pred) ? pred.tax_paid.round(2) : null
			this.hasTax = Boolean(this.expense.tax)
			this.$store.errorList.tax = (this.expense.tax === null)

			// Subtotal
			this.expense.cost = ('subtotal' in pred) ? pred.subtotal.round(2) : null
			this.$store.errorList.cost = (this.expense.cost === null)

			// Expense Code
			this.expense.code_id = ('expense_code_id' in pred) ? Number(pred.expense_code_id) : null
			this.$store.errorList.code_id = !Boolean(this.expense.code_id)

			// Expense Group (must be after code because of groupSelected)
			this.expense.group_id = ('expense_group_id' in pred) ? Number(pred.expense_group_id) : null
			this.$store.errorList.group_id = !Boolean(this.expense.group_id)
			this.groupSelected(this.expense.group_id)
		},

		predictJobService(purchase_datetime_str) {
			
			let purchaseDatetime;
			try {
				// Ensure string is a valid datetime
				purchaseDatetime = moment(purchase_datetime_str).utc().format("YYYY-MM-DD HH:mm:ss");

			} catch (e) {
				// Unable to parse -- mark fields for manual
				this.$store.errorList.job_id = true
				this.$store.errorList.service_id = true
				this.spinner(false)
				return
			}
			
			const payload = {
				fields: ['job_id', 'service_id'],
				filters: [
					['user_id', this.$store.userDetails.id],
					['time_in <=', purchaseDatetime],
					['time_out >=', purchaseDatetime],

					['user_id', this.$store.userDetails.id, 'or'],
					['time_in <=', purchaseDatetime],
					['time_out', '0000-00-00 00:00:00'],
					
				],
				limit: 1
			}

			this.getJSON("TimeLog/get", payload).then(response => {
				if (response.success && response.data.length) {
					const timelog = response.data[0]
					this.expense.job_id = Number(timelog.job_id)
					this.expense.service_id = Number(timelog.service_id)

					if (timelog.job_id > 0) {
						this.setSelectedJob(timelog.job_id, 'Job')
					} else if (timelog.service_id > 0) {
						this.setSelectedJob(timelog.service_id, 'Service')
					}

					this.fetchJobPOs()

				} else {
					this.$store.errorList.job_id = true
					this.$store.errorList.service_id = true
				}

				this.spinner(false)
			})

		},

		predictFile() {
			this.predictionFetched = true
			this.spinner(true)

			const payload = {
				id: this.expense.image_id,
				//fields: ['transaction_number', 'purchase_datetime', 'due_date', 'expense_group', 'subtotal', 'tax_paid']
			}

			this.postData("ReceiptImage/predict", payload, true).then(response => {
				if (response.success) {
					if ('purchase_datetime' in response.data && response.data.purchase_datetime)
						this.predictJobService(response.data.purchase_datetime)
					else
						this.spinner(false)

					this.mapPredictionToExpense(response.data)
				} else {
					this.predictionFetched = false
					this.spinner(false)
				}
			})
		},

		checkSupplierInvoiceNum() {
			let vm = this

			this.$nextTick(() => {

				if (this.expense.invoice_num && (this.expense.supplier_id > 0 ||  this.expense.purchase_order_id > 0)) {

					//check unsubmitted list first, then check on server
					let duplicateExpense = this.mutatedExpensesToAdd.find(exp => exp.invoice_num == this.expense.invoice_num && (exp.supplier_id == this.expense.supplier_id || exp.purchase_order_id == this.expense.purchase_order_id))

					if (duplicateExpense) {
						this.showSupplierWarning = true
						this.$forceUpdate()
					}
					else {
						let supplierId = null

						if (this.expense.purchase_order_id) {
							let po = this.purchaseOrders.find(po => po.id == this.expense.purchase_order_id)
							if (po && 'Supplier' in po && po.Supplier && 'id' in po.Supplier && po.Supplier.id)
								supplierId = po.Supplier.id
						} else {
							supplierId = this.expense.supplier_id
						}

						let params = {
							filters: [
								['invoice_num', this.expense.invoice_num],
								['supplier_id', supplierId]
							],
							limit: 1,
							count: true
						}

						this.getJSON('Expense/get', params).then(response => {
							this.showSupplierWarning = (response.success && response.count > 0)
							vm.$forceUpdate()
						})
					}

				} else {
					this.showSupplierWarning = false
					this.$forceUpdate()
				}
			})
		},
		setSelectedJob(id,type) {
			let vm = this

			this.getJSON(type + "/find/" + id).then(response => {
				if (response.success) {
					vm.selectedJob = response.data
					this.$forceUpdate()
				}
			})
		},
		setPoPreviewSrc(po_id) {
			let po = this.purchaseOrders.find(po => po.id == po_id)

			if (po)
				this.poPreviewSrc = window.apiBase+"PurchaseOrder/pdf?slug="+po.slug+"&token="+this.$store.sessionToken+"&humanReadable=true"
			else
				this.poPreviewSrc = false
		},
		imageUploaded(response) {
			this.expense.image_id = response.data.id
			this.predictionFetched = false   // new file => new prediction can be made
		},
		groupSelected(group_id) {
			let vm = this

			let payload = {
				filters: [
					['group_id',group_id]
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("ExpenseCode/get",payload).then(response => {

					vm.expenseCodesFiltered = response.data.map(code => {
						code.display = code.code + ": " + code.description
						return code
					})

					resolve(response)
				})
			})
		},
		poToggleChange(hasPo) {
			
			let vm = this

			return new Promise((resolve,reject) => {

				this.checkSupplierInvoiceNum()

				if (hasPo) {
					this.expense.supplier_id = null
					this.fetchJobPOs().then(response => {
						resolve(response)
					})
				}
				else {
					this.expense.purchase_order_id = null
					this.fetchSuppliers().then(response => {
						resolve(response)
					})
				}
			})
		},
		poSelected(po_id) {
			let po = this.purchaseOrders.find(po => po.id == po_id)
			this.expense.purchase_order_id = po_id

			if (po && !this.expense.description)
				this.expense.description = po.subject

			this.checkSupplierInvoiceNum()
			this.setPoPreviewSrc(po_id)
		},
		dateOfPurchaseChange(date) {
			if (this.moment(date).isAfter(this.moment())) {
				this.$store.errorList.purchase_date = true
				this.purchaseDateError = "The purchase date cannot be in the future"
			}
			else {
				this.$store.errorList.purchase_date = false
				this.purchaseDateError = false
			}
		},
		copyExpense(record,index) {
			let vm = this
			this.expense = this.cloneObj(record)

			this.uploadedImage = this.cloneObj(record.ReceiptImage)
			this.hasPurchaseOrder = record.purchase_order_id > 0

			let copyFields = ["purchase_date","job_id","service_id","purchase_order_id","supplier_id","group_id","code_id","image_id","invoice_num"]

			this.expense = {}
			copyFields.forEach(key => {

				if (key in record && record[key])
					vm.$set(vm.expense,key,record[key])
			})

			this.groupSelected(vm.expense.group_id)
		},
		addExpense() {
			let vm = this

			//check required fields
			let allRequiredFieldsFilled = true;
			this.requiredFields.forEach(field => {
				if (!(field in vm.expense) || !vm.expense[field]) {
					vm.$store.errorList[field] = true
					allRequiredFieldsFilled = false
				}
			})

			if (allRequiredFieldsFilled) {

				let expense = this.cloneObj(this.expense)

				let code = this.expenseCodesFiltered.find(code => code.id == expense.code_id)
				if (code)
					expense.ExpenseCode = code

				let po = this.purchaseOrders.find(po => po.id == expense.purchase_order_id)
				if (po)
					expense.PurchaseOrder = po

				let supplier = this.suppliers.find(supplier => supplier.id == expense.supplier_id)
				if (supplier)
					expense.Supplier = supplier

				expense.Job = false
				expense.Service = false
				if (this.selectedJob) {
					if (expense.service_id > 0) 
						expense.Service = this.selectedJob
					else if (expense.job_id > 0)
						expense.Job = this.selectedJob
				}

				expense.payment_method = "Invoiced"
				expense.user_id = this.$store.userDetails.id
				expense.ReceiptImage = this.uploadedImage

				let taxAmount = expense.tax
				if (expense.qbo_tax_id > 0) {
					taxAmount = expense.cost * vm.qboTaxRate / 100
					taxAmount = taxAmount.round(2)
				}

				expense.taxAmount = taxAmount
				expense.tax = taxAmount

				this.expensesToAdd.push(expense)

				this.resetForm()
			}
			else {
				vm.alertFail("Please fill out all required fields")
				vm.$forceUpdate()
			}
		},
		editExpense(expense,index) {
			let vm = this

			let editedExpense = {}

			Object.keys(this.expense).forEach(key => {
				if (key != 'supplier_id' && key != 'purchase_order_id')
					editedExpense[key] = expense[key]
			})

			this.expense = editedExpense
			this.uploadedImage = expense.ReceiptImage

			this.hasPurchaseOrder = expense.purchase_order_id > 0

			this.poToggleChange(expense.purchase_order_id > 0).then(response => {

				vm.$nextTick(() => {
					if (expense.purchase_order_id > 0) 
						//set selected po
						vm.expense.purchase_order_id = expense.purchase_order_id
					else 
						//set selected supplier
						vm.expense.supplier_id = expense.supplier_id

					this.groupSelected(expense.group_id).then(response => {
						vm.expense.code_id = expense.code_id
					})

					this.hasTax = expense.tax > 0

					this.expensesToAdd.splice(index,1)
					this.isEditing = true
				})
			})
		},
		removeExpense(expense,index) {
			this.expensesToAdd.splice(index,1)
		},
		resetForm() {
			this.uploadedImage = null

			this.expense = {
				image_id: null,
				description: "",
				invoice_num: "",
				purchase_date: null,
				due_date: null,
				job_id: null,
				service_id: null,
				group_id: null,
				code_id: null,
				supplier_id: null,
				cost: null,
				tax: null,
				purchase_order_id: null,
				qbo_tax_id: null
			}

			this.expenseCodesFiltered = []
			this.$store.errorList = []
			this.isEditing = false
			this.hasTax = false
			this.hasPurchaseOrder = false
			this.poPreviewSrc = false
		},
		submitExpenses() {
			let vm = this

			let payload = {
				records: JSON.stringify(this.expensesToAdd.map(expense => {

					let fields = ["image_id","description","invoice_num","purchase_date","due_date","job_id","service_id","group_id","code_id","supplier_id","tax","cost","user_id","payment_method","qbo_tax_id"]

					let obj = {}

					fields.forEach(key => {
						obj[key] = expense[key]
					})

					if ("purchase_order_id" in expense && expense.purchase_order_id > 0)
						obj.purchase_order_id = expense.purchase_order_id

					if ("supplier_id" in expense && expense.supplier_id > 0)
						obj.supplier_id = expense.supplier_id
					else if ("PurchaseOrder" in expense && expense.PurchaseOrder && expense.PurchaseOrder.supplier_id > 0)
						obj.supplier_id = expense.PurchaseOrder.supplier_id

					return obj
				}))
			}

			this.working = true

			//this.postData("Expense/save",payload)

			this.postData("Expense/save-batch",payload,true).then(response => {
				if (response.success) {
					vm.alertSaved(response.data.records_saved+" expenses saved")
					vm.expensesToAdd = []
				}

				vm.working = false
			})
		},
		fetchJobPOs() {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.$nextTick(() => {

					if (vm.expense.service_id > 0 || vm.expense.job_id > 0) {

						let jobKey = "job_id"
						if (vm.expense.service_id > 0)
							jobKey = "service_id"

						let params = {
							filters: [
								[jobKey,vm.expense[jobKey]],
								["status !=","Draft"],
								["is_closed",0]
							],
							include: ["Contact"]
						}

						vm.getJSON("PurchaseOrder/get",params).then(response => {
							if (response.success)
								vm.purchaseOrders = response.data

							resolve(response)
						})

					}
				})
			})
		},
		fetchSuppliers() {
			let vm = this

			let params = {
				filters: [
					["is_supplier",1]
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("Contact/get",params).then(response => {
					if (response.success)
						vm.suppliers = response.data

					resolve(response)
				})
			})
		},
		fetchData() {
			this.spinner(true)

			let promises = [
				this.fetchModel('ExpenseGroup'),
				this.fetchQBOCreditCardAccountsUserSettings()
			]

			if (this.qboIsActive)
				promises.push(this.fetchQboSalesTaxes())

			let vm = this

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
			
		},
	},
	created() {
		this.fetchData()
	}
}
</script>

<style type="text/css" scoped>

	.expense-total {
		box-shadow: inset 0 0 4px #efefef;
		border: 1px solid #ced4da;
		padding: 5px;
		background-color: #f5f5f5;
	}
	
	.expense-total .total-amount {
		font-size: 24pt;
		text-align: right;
	}

</style>